export function getLogo (state) {
  const theme = state.themeDetail
  if (!theme) {
    return ''
  }

  return theme.logo
}

export function getBannerImages (state) {
  const theme = state.themeDetail
  if (!theme || !theme.banner_images) {
    return []
  }

  return theme.banner_images
}

export function getBannerMobileImages (state) {
  const theme = state.themeDetail
  if (!theme || !theme.mobile_banner_images) {
    return getBannerImages(state)
  }

  return theme.mobile_banner_images
}
